import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { pages } from './utils/common';
import useCommunicationRoutes from './views/modules/communications/useCommunication.routes';
import LoginViewRoot from './views/modules/login';
import useProfileRoutes from './views/modules/profile/useProfile.routes';
import useAcademicsRoutes from './views/modules/academics/useAcademics.routes';
import useDashboardRoutes from './views/modules/dashboard/useDashboard.routes';
import useStudentsRoutes from './views/modules/students/useStudents.routes';
import useStaffRoutes from './views/modules/staff/useStaff.routes';
import useFinanceRoutes from './views/modules/finance/useFinance.routes';
import useAdministrationRoutes from './views/modules/administration/useAdministration.routes';
import useAnalyticsRoutes from './views/modules/analytics/useAnalytics.routes';
import useSettingsRoutes from './views/modules/settings/useSettings.routes';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import useUsersRoutes from './views/modules/users/useUsers.routes';
import useGuardianRoutes from './views/modules/guardian/guardian.routes';
import { BreakpointProvider } from './components/BreakpointProvider';

const AllRoutes = () => {
  return (
    <BreakpointProvider>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <BrowserRouter basename={'/'}>
          <Routes>
            <Route path={pages.auth.path} element={<App />}>
              <Route index element={<LoginViewRoot />} />
              <Route path={pages.auth.path} element={<LoginViewRoot />} />
              <Route path={pages.logout.path} element={<LoginViewRoot />} />
              {useDashboardRoutes()}
              {useStudentsRoutes()}
              {useStaffRoutes()}
              {useAcademicsRoutes()}
              {useCommunicationRoutes()}
              {useFinanceRoutes()}
              {useAnalyticsRoutes()}
              {useAdministrationRoutes()}
              {useUsersRoutes()}
              {useSettingsRoutes()}
              {useProfileRoutes()}
              {useGuardianRoutes()}
            </Route>
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </BreakpointProvider>
  );
};
export default AllRoutes;
